import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";

export const AverageDayRoute: ViewRoute = {
  [RouteNames.averageDay]: () => {
    return RouteNames.singleOccasion;
  }
};
